import type { SaleOut } from "@shop-ledger/shared-types";
import { apiRequest } from "../lib/apiClient";
import type { SaleOut as SaleOutExt } from "./types";

/** `GET /sales` — used by `OnlineOrdersPage` to surface `Sale.source === "ECOMMERCE"`
 * rows for the ECOM_MGR role (§10). Filtering by source happens client-side; the backend
 * route only accepts an optional `branch_id` query param
 * (`backend/app/api/v1/sales.py::list_sales`), not a `source` filter. */
export async function listSales(accessToken: string, branchId?: string): Promise<SaleOut[]> {
  return apiRequest<SaleOut[]>("/sales", { accessToken, query: { branch_id: branchId } });
}

/** Same `GET /sales` route, typed against the local (post-integration-pass) `SaleOut` from
 * `./types` instead of the now-stale `@shop-ledger/shared-types` shape — needed by
 * `ReturnsPage` for `items[].id` (the `sale_item_id` a return line references) alongside
 * fields shared-types' version doesn't have (`customer_id`/`currency`). */
export async function listSalesExt(accessToken: string, branchId?: string): Promise<SaleOutExt[]> {
  return apiRequest<SaleOutExt[]>("/sales", { accessToken, query: { branch_id: branchId } });
}
